export default {
  hero: {
    title: "Allgemeine Geschäftsbedingungen AGB"
  },
  toc: {
    title: "Inhalt"
  },
  sections: [
    {
      id: "section1",
      title: "1 Geltungsbereich",
      blocks: [
        "Diese Allgemeinen Geschäftsbedingungen regeln abschliessend die Nutzung der digitalen Plattform NutriBot.",
        "Betreiber ist:\nEat&Drink 7day GmbH\nFrauenfelderstrasse 4\n8252 Schlatt\nSchweiz",
        "Mit der Nutzung der Plattform kommt ein verbindlicher Vertrag zustande.",
        "Der Nutzer bestätigt, diese AGB gelesen, verstanden und akzeptiert zu haben.",
        "Abweichende Bedingungen des Nutzers werden ausdrücklich ausgeschlossen."
      ]
    },
    {
      id: "section2",
      title: "2 Leistungscharakter",
      blocks: [
        "NutriBot ist ein rein technisches System zur automatisierten Generierung von Inhalten.",
        "Die Plattform stellt keinerlei Beratung, Empfehlung oder Bewertung dar.",
        "Sämtliche Inhalte sind unverbindlich, generisch und ohne Anspruch auf Richtigkeit oder Eignung.",
        "Es wird ausdrücklich keine individuelle oder persönliche Analyse durchgeführt.",
        "Ein bestimmter Erfolg wird nicht geschuldet."
      ]
    },
    {
      id: "section3",
      title: "3 Ausschluss jeglichen Vertrauens",
      blocks: [
        "Der Nutzer bestätigt ausdrücklich:",
        [
          "keine Inhalte als verlässliche Entscheidungsgrundlage zu verwenden",
          "keine berechtigte Erwartung an Richtigkeit oder Vollständigkeit zu haben",
          "keine schutzwürdige Vertrauensposition gegenüber NutriBot zu begründen"
        ],
        "Die Nutzung erfolgt ohne jegliches Vertrauen in die Inhalte."
      ]
    },
    {
      id: "section4",
      title: "4 Vollständige Eigenverantwortung",
      blocks: [
        "Der Nutzer trägt die alleinige und uneingeschränkte Verantwortung für:",
        [
          "sämtliche Entscheidungen",
          "sämtliche Handlungen",
          "sämtliche Folgen"
        ],
        "die im Zusammenhang mit der Nutzung von NutriBot stehen.",
        "Jegliche Nutzung erfolgt vollständig auf eigenes Risiko."
      ]
    },
    {
      id: "section5",
      title: "5 Medizinischer Ausschluss",
      blocks: [
        "Die Plattform ist nicht für medizinische Zwecke bestimmt.",
        "Die Inhalte dürfen nicht zur Diagnose, Behandlung oder Prävention verwendet werden.",
        "Der Nutzer ist verpflichtet, bei gesundheitlichen Themen ausschliesslich qualifiziertes Fachpersonal zu konsultieren."
      ]
    },
    {
      id: "section6",
      title: "6 KI-Risiken",
      blocks: [
        "Der Nutzer erkennt an:",
        [
          "Inhalte werden vollständig automatisiert erzeugt",
          "es erfolgt keine menschliche Kontrolle",
          "Fehler, Widersprüche und Ungeeignetheit sind systemimmanent"
        ],
        "Eine inhaltliche Verlässlichkeit wird nicht zugesichert."
      ]
    },
    {
      id: "section7",
      title: "7 Nutzungspflichten",
      blocks: [
        "Untersagt sind insbesondere:",
        [
          "jegliche missbräuchliche Nutzung",
          "automatisierte Nutzung",
          "Umgehung von Schutzmechanismen",
          "kommerzielle Verwertung",
          "Nutzung zur Entwicklung konkurrierender Systeme"
        ],
        "Der Betreiber kann Zugänge jederzeit und ohne Begründung sperren."
      ]
    },
    {
      id: "section8",
      title: "8 Nutzungsrechte",
      blocks: [
        "Es wird ausschliesslich ein widerrufbares, nicht übertragbares Nutzungsrecht eingeräumt.",
        "Alle Rechte verbleiben vollständig beim Betreiber."
      ]
    },
    {
      id: "section9",
      title: "9 Verfügbarkeit",
      blocks: [
        "Es besteht keinerlei Anspruch auf:",
        [
          "Verfügbarkeit",
          "Funktionsfähigkeit",
          "Fehlerfreiheit",
          "Datenbeständigkeit"
        ],
        "Der Betrieb kann jederzeit geändert oder eingestellt werden."
      ]
    },
    {
      id: "section10",
      title: "10 Haftung",
      blocks: [
        "Soweit gesetzlich zulässig, ist jede Haftung ausgeschlossen.",
        "Dies gilt insbesondere für:",
        [
          "jede Art von Schäden",
          "unmittelbare und mittelbare Schäden",
          "wirtschaftliche Verluste",
          "Datenverluste",
          "Fehlentscheidungen",
          "gesundheitliche Folgen"
        ],
        "Eine Haftung besteht ausschliesslich bei vorsätzlichem oder grob fahrlässigem Verhalten."
      ]
    },
    {
      id: "section11",
      title: "11 Erweiterter Haftungsausschluss",
      blocks: [
        "Der Betreiber übernimmt keinerlei Verantwortung für:",
        [
          "die Interpretation der Inhalte",
          "die Anwendung der Inhalte",
          "Ergebnisse oder Folgen der Nutzung"
        ],
        "Der Nutzer verzichtet ausdrücklich auf jegliche Ansprüche, soweit gesetzlich zulässig."
      ]
    },
    {
      id: "section12",
      title: "12 Freistellung",
      blocks: [
        "Der Nutzer verpflichtet sich, den Betreiber vollständig freizustellen von:",
        [
          "sämtlichen Ansprüchen Dritter",
          "sämtlichen Schäden",
          "sämtlichen Kosten"
        ],
        "einschliesslich Rechtsverfolgungskosten.",
        "Dies gilt uneingeschränkt für alle Folgen der Nutzung."
      ]
    },
    {
      id: "section13",
      title: "13 Abonnements",
      blocks: [
        "Abonnements verlängern sich automatisch.",
        "Es besteht kein Anspruch auf Rückerstattung."
      ]
    },
    {
      id: "section14",
      title: "14 Kündigung",
      blocks: [
        "Der Betreiber kann jederzeit und ohne Angabe von Gründen kündigen oder sperren."
      ]
    },
    {
      id: "section15",
      title: "15 Datenschutz",
      blocks: [
        "Gemäss separater Datenschutzerklärung. (Link)"
      ]
    },
    {
      id: "section16",
      title: "16 Änderungen",
      blocks: [
        "Änderungen sind jederzeit möglich.",
        "Die weitere Nutzung gilt als Zustimmung."
      ]
    },
    {
      id: "section17",
      title: "17 Recht und Gerichtsstand",
      blocks: [
        "Es gilt ausschliesslich Schweizer Recht.",
        "Gerichtsstand ist Schlatt, Schweiz, soweit zulässig."
      ]
    },
    {
      id: "section18",
      title: "18 Salvatorische Klausel",
      blocks: [
        "Unwirksame Bestimmungen werden durch wirtschaftlich gleichwertige ersetzt."
      ]
    }
  ],
  finalStatement: "Finale Absicherungs-Klausel\n\nDer Nutzer bestätigt ausdrücklich, dass die Nutzung von NutriBot vollständig eigenverantwortlich erfolgt und keinerlei Ansprüche gegenüber der Eat&Drink 7day GmbH begründet werden."
};